import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const Styled = {
    Container: styled(Box)(({ theme }) => ({
        display: 'flex',
        width: '100%',
        height: '100dvh',
        minHeight: 0,
        overflow: 'hidden',
        position: 'relative',
        isolation: 'isolate',
        backgroundColor: theme.palette.background.default,
        backgroundImage:
            theme.palette.mode === 'light'
                ? `radial-gradient(circle at 14% -10%, ${alpha(
                      theme.palette.primary.main,
                      0.09,
                  )} 0%, transparent 29%), radial-gradient(circle at 88% 105%, ${alpha(
                      theme.palette.info.main,
                      0.045,
                  )} 0%, transparent 26%)`
                : `radial-gradient(circle at 14% -10%, ${alpha(
                      theme.palette.primary.main,
                      0.13,
                  )} 0%, transparent 28%), radial-gradient(circle at 88% 105%, ${alpha(
                      theme.palette.info.main,
                      0.055,
                  )} 0%, transparent 24%)`,

        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            minHeight: '100dvh',
            overflow: 'visible',
        },
    })),
    SidebarContainer: styled(Box)(({ theme }) => ({
        position: 'relative',
        width: 288,
        minWidth: 288,
        height: '100dvh',
        flexShrink: 0,
        padding: theme.spacing(2, 0, 2, 2),
        overflow: 'hidden',

        [theme.breakpoints.between('sm', 'lg')]: {
            width: 266,
            minWidth: 266,
            padding: theme.spacing(1.5, 0, 1.5, 1.5),
        },
    })),
    Card: styled('main')(({ theme }) => ({
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
        padding: theme.spacing(2),
        gap: theme.spacing(1.5),

        [theme.breakpoints.between('md', 'lg')]: {
            padding: theme.spacing(1.5),
        },

        [theme.breakpoints.down('md')]: {
            padding: 0,
            gap: 0,
        },

        [theme.breakpoints.down('sm')]: {
            minHeight: '100dvh',
            height: 'auto',
            overflow: 'visible',
        },
    })),
};

export { Styled };
